import Draft from '@/components/library/pages/Draft.vue';
import Email from '@/components/library/pages/Email.vue';
import Flagship from '@/components/library/pages/Flagship.vue';
import Published from '@/components/library/pages/Published.vue';
import Unpublished from '@/components/library/pages/Unpublished.vue';
import Templates from '@/components/library/templates/Templates.vue';
import DocumentLibrary from '@/views/DocumentLibrary.vue';
import CreateJobPostView from '@/views/CreateJobPostView.vue';

export const documents = (authDataStore) => ([
  {
    name: 'create-job-post',
    path: '/documents/create',
    component: CreateJobPostView,
    meta: { title: 'Write a Job Post' },
    beforeEnter: (to, from, next) => {
      if (authDataStore.checkRbacPermissions(['createJob'])) {
        next();
      } else {
        next({ name: 'root' });
      }
    },
  },
  {
    path: '/documents/',
    name: 'document-library',
    component: DocumentLibrary,
    meta: { title: 'Library' },
    children: [
      {
        name: 'email',
        path: 'email',
        component: Email,
        meta: { title: 'Emails' },
      },
      {
        name: 'published',
        path: 'published',
        component: Published,
        meta: { title: 'Published Posts' },
      },
      {
        name: 'unpublished',
        path: 'unpublished',
        component: Unpublished,
        meta: { title: 'Unpublished Posts' },
      },
      {
        name: 'draft',
        path: 'draft',
        component: Draft,
        meta: { title: 'Draft Posts' },
      },
      {
        name: 'flagship',
        path: 'flagship',
        component: Flagship,
        meta: { title: 'Flagship Posts' },
      },
      {
        name: 'closed',
        path: 'closed',
        redirect: (to) => ({ name: 'unpublished', query: { ...to.query, closedRedirect: 'true' } }),
      },
      {
        name: 'templates',
        path: 'templates/:from?',
        props: true,
        meta: { timer: 3000, title: 'Templates' },
        component: Templates,
        beforeEnter: async (to, from, next) => {
          if (authDataStore.checkRbacPermissions(['viewTemplates'])) {
            next();
          } else {
            next({ name: 'root' });
          }
        },
      },
    ],
  },
]);
